<template>
  <owal-modal-panel
    :title="title"
    :bottom-buttons="buttons"
    presentation-style="form"
    @button-click="handleButton"
    >
    <owal-form
      ref="form"
      :form="this.inputForm"
      :is-initial-submission="isInitialSubmission"
      :initial-submission="initialSubmission"
      :endpoint="this.endpoint"
      :embedded="true"
      @change="updateButtons"
      @submit-end="handleSubmit"
      :metadata="metadata"
      />
  </owal-modal-panel>
</template>

<script>
import OwalForm from '@/libraries/owal-ui/forms/OwalForm'
import OwalModalPanel from '@/libraries/owal-ui/panels/OwalModalPanel'
import * as profiles from '@/libraries/user-management'
import { mapGetters } from 'vuex'

export default {
  name: 'OwalAddFace',
  components: { OwalForm, OwalModalPanel },
  props: {
    faceToEdit: {
      type: Object,
      default: undefined,
      required: false,
    },
    initialImage: {
      type: String,
      default: undefined,
      required: false,
    },
  },
  data () {
    return {
      readyToSubmit: false,
      inputForm: profiles.addFace,
    }
  },
  computed: {
    ...mapGetters(['currentDomainUUID']),
    metadata () {
      return {
        domain_uuid: this.currentDomainUUID,
      }
    },
    isInitialSubmission () {
      return !this.faceToEdit
    },
    title () {
      return this.faceToEdit ? 'Edit Face' : 'Add Face'
    },
    endpoint () {
      let endpoint = '/api/v6/faces'
      if (this.faceToEdit) {
        const uuid = this.faceToEdit.frontend_face_uuid
        if (uuid) {
          endpoint = `${endpoint}/${uuid}`
        }
      }
      return endpoint
    },
    initialSubmission () {
      let face = this.faceToEdit
      const image = this.initialImage
      if (!face) {
        if (image) {
          face = {
            images: [{
              orientation: 'front',
              thumbnail_uri: image,
            }],
          }
        } else {
          return undefined
        }
      }
      const submission = this.inputForm.initializationTemplate.processSubmission(face)
      // console.log(`Submission: ${JSON.stringify(submission, null, 2)}`)
      // console.log(`Face: ${JSON.stringify(face, null, 2)}`)
      return submission
    },
    buttons: function () {
      let buttons = [{
        title: 'cancel',
        identifier: 'close',
      }]

      if (this.readyToSubmit) {
        buttons.push({
          title: 'Save',
          identifier: 'save',
        })
      }

      return buttons
    },
  },
  methods: {
    handleSubmit: function ({ submission, endpoint, response, success, error }) {
      let uuid = ''
      if (response && response.data) {
        uuid = response.data.frontend_face_uuid
      }
      this.closeWindow(success, uuid)
    },
    handleButton (identifier) {
      if (identifier === 'close') {
        this.closeWindow(false) // Cancel button
      } else if (identifier === 'save') {
        this.$refs.form.submit()
      }
    },
    closeWindow (didSubmit, uuid) {
      const face = this.faceToEdit
      const isEdit = !!face
      const action = isEdit ? 'edit' : 'add'
      uuid = isEdit ? face.uuid : uuid

      let payload = {
        success: didSubmit,
        action,
        uuid,
      }
      this.$emit('close', payload)
    },
    updateButtons: function (submission) {
      this.readyToSubmit = this.inputForm.validateSubmission(submission)
    },
  },
}
</script>

<style scoped>

</style>
